import React from "react";

import InformationTabBase from "./InformationTabBase";
import {Col, Container, Form, Row} from "react-bootstrap";
import InputSearch from "../../../../ui/forms/InputSearch";
import ShadowScrollbars from "../../../../ui/custom_scrollbars/ShadowScrollbars";

import SelectFilter from "../../../../ui/select/SelectFilter";
import SelectSearch from "../../../../ui/select/SelectSearch";

import {Query} from "@apollo/react-components";
import {fullProfileQueries} from "../../../../../store/actions/Dashboard/FullProfile/FullProfileGraphQL";
import CareerStatsTabContent from "./career_stats_tab/CareerStatsTabContent";

class CareerStatsTab extends InformationTabBase {
    render = () => {
        return (
            <div className="career-stats-tab">
                <ShadowScrollbars disableHorizontalScrolling autoHide autoHideTimeout={1000} autoHideDuration={200} thumbMinSize={30} universal={true}>
                    {this.renderFilters()}
                    {this.renderContent()}
                </ShadowScrollbars>
            </div>
        );
    };


    renderFilters = () => {
        return (
            <Query query={fullProfileQueries.getCareerStatsFilters}>
                {({data, loading, error}) => {

                    let competitionsOptions = [], seasonsOptions = [], locationsOptions = [];

                    if (!loading && !error) {
                        const withSelectAllOptions = options => [{value: 'all', key: 'all', label: 'Select All'}, ...options];
                        const {competitions, seasons, locations} = data;
                        competitionsOptions = withSelectAllOptions(competitions?.map(item => ({value: item.id, key: item.id, label: item.name})));
                        seasonsOptions = withSelectAllOptions(seasons?.map(item => ({value: item.id, key: item.id, label: item.name})));
                        locationsOptions = withSelectAllOptions(locations?.map(item => ({value: item.id, key: item.id, label: item.name})));
                    }

                    return (
                        <div className="filter-search-container">
                            <Form onSubmit={this.handleSubmit} className="toolbar">
                                <Form.Row className="row form">
                                    <Col xl={2} lg={3} xs={6} className="filter">
                                        <SelectFilter selected="true" loading={loading} error={error} type="sm" name="regions" placeholder="All Competitions Played" options={competitionsOptions}/>
                                    </Col>
                                    <Col xl={2} lg={3} xs={6} className="filter">
                                        <SelectSearch selected="true" loading={loading} error={error} type="sm" name="countries" placeholder="All Seasons" searchPlaceholder="Search Seasons" options={seasonsOptions}/>
                                    </Col>
                                    <Col xl={2} lg={3} xs={6} className="filter">
                                        <SelectSearch selected="true" loading={loading} error={error} type="sm" name="countries" placeholder="All Locations Played" searchPlaceholder="Search Conuntry" options={locationsOptions}/>
                                    </Col>
                                    <Col xl={3} lg={3} xs={6} className="ml-auto filter">
                                        <InputSearch size="sm"/>
                                    </Col>
                                </Form.Row>
                            </Form>
                        </div>
                    );
                }}
            </Query>
        );
    };
    renderContent = () => {
        return <CareerStatsTabContent/>
    };

    handleSubmit = (event) => {
    };
}

export default CareerStatsTab;
